const _tracker = (function ($) {
  const _handlers = [];

  // private functions
  function _register(event, action, opts) {
    opts = opts || {};

    if (typeof event !== "string") {
      throw Error("SB.CreateTrackingHelper:: Invalid tracking trigger.");
    }
    // Only these two are required
    if (!action || typeof action !== "function") {
      throw Error("SB.CreateTrackingHelper:: Invalid options.");
    }
    _handlers.push({
      event,
      action,
      onInit: opts.onInit,
      trigger: opts.trigger,
    });
  }

  function _attach() {
    $.each(_handlers, (index, handler) => {
      if (handler.event) {
        const el = handler.trigger || window;
        let initResponse = true;
        if (typeof handler.onInit === "function") {
          initResponse = handler.onInit();
        }
        if (initResponse) {
          $(el).on(handler.event, handler.action);
        } else {
          throw Error(
            "SB.CreateTrackingHelper:: Tracker didn't pass init validation.",
          );
        }
      }
    });
  }

  // public functions
  return {
    register: _register,
    attach: _attach,
  };
})(window.jQuery);

// Create or retrieve the global namespace
window.SB = window.SB || {};

// Add the tracker creator to the namespace
window.SB.CreateTrackingHelper = function () {
  return Object.create(_tracker);
};
